import React, { useState, useContext, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { useQuery } from "@apollo/react-hooks";
import { faultQueries } from "../../../resolvers";
import { ReportContext } from "../contexts";
import { CustomToolbar, Loading, textLabels } from "../../../../components";
import _, { isArray } from "lodash";
import moment from "moment";
import { handleExporttoExcel } from "../../../components";
import Container from "@material-ui/core/Container";
import { useDropzone } from "react-dropzone";
import * as XLSX from "xlsx/xlsx.mjs";

export default function Component({ currentcompany }) {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  moment.locale();
  const { state, setState } = useContext(ReportContext);
  const [variables, setVariables] = useState({
    data: {
      company: currentcompany.id,
      isActive: true,
    },
  });
  const changeState = (value) => {
    setState({ ...state, ...value });
  };

  const { loading, data, refetch } = useQuery(faultQueries.ALL, {
    fetchPolicy: "cache-and-network",
    variables,
    onError(err) {
      console.log(err);
    },
  });
  //console.log(data);
  const handleRefetch = () => {
    refetch();
  };

  const [initialState, setInitialState] = useState([]);

  const handleDownload = async () => {
    const sheet = "Anzer Web Kayıtları";
    const file = moment().format("DD.MM.YYYY").toString();
    const column = [
      { header: "Seri No", key: "serino", width: 20 },
      { header: "Kontrol No", key: "controlNo", width: 20 },
      { header: "Dolum Yapılan Kooperatif", key: "product", width: 20 },
      {
        header: "Dolum Yapılan Ambalaj Boyutu (gr)",
        key: "dimensions",
        width: 20,
      },
      { header: "Dolum Yeri", key: "productPalace", width: 20 },
      { header: "Dolum Tarihi", key: "productDate", width: 20 },
      { header: "Açıklama", key: "description", width: 20 },
    ];
    const rows = _.orderBy(initialState, ["productDate"], ["desc"]);
    const row = await rows.map((x) => {
      let type = "";
      if (isArray(x.type)) {
        x.type.forEach((e) => {
          type += e + ", ";
        });
      }
      return {
        machine: x.machine.name,
        start: moment(x.start).format("DD.MM.YYYY HH:mm:ss"),
        startUser: `${x.startUser ? x.startUser.name : ""} ${
          x.startUser ? x.startUser.surname : ""
        }`,
        finish: moment(x.finish).format("DD.MM.YYYY HH:mm:ss"),
        finishUser: `${x.finishUser ? x.finishUser.name : ""} ${
          x.finishUser ? x.finishUser.surname : ""
        }`,
        difference: x.difference,
        type,
        description: x.description,
      };
    });
    handleExporttoExcel(file, sheet, column, row);
  };

  const columns = [
    {
      name: "id",
      label: "id",
      options: {
        display: "excluded",
        filter: false,
        sort: false,
      },
    },
    {
      name: "serino",
      label: "Seri No",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "controlNo",
      label: "Kontrol No",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "product",
      label: "Dolum Yapılan Kooperatif",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "dimensions",
      label: "Dolum Yapılan Ambalaj Boyutu (gr)",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "productPalace",
      label: "Dolum Yeri",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "productDate",
      label: "Dolum Tarihi",
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "description",
      label: "Açıklama",
      options: {
        filter: false,
        sort: true,
      },
    },
  ];

  const options = {
    filter: true,
    print: false,
    download: false,
    viewColumns: true,
    responsive: "scrollMaxHeight",
    fixedHeader: true,
    customToolbar: () => (
      <CustomToolbar
        handleRefetch={handleRefetch}
        handleDownload={handleDownload}
      />
    ),
    selectableRows: "none",
    textLabels,
  };

  const handleUpload = () => {
    const files = acceptedFiles,
      f = files[0];
    const reader = new FileReader();
    reader.onload = function (e) {
      const data = e.target.result;
      const readedData = XLSX.read(data, { type: "binary" });
      const wsname = readedData.SheetNames[0];
      const ws = readedData.Sheets[wsname];
      const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
      //console.log(wsname, ws);
      console.log(dataParse);
      setInitialState(dataParse);
    };
    reader.readAsBinaryString(f);
  };

  useEffect(() => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      console.log("sdaf");
      handleUpload();
    }
  }, [acceptedFiles]);

  useEffect(() => {
    if (data) {
      setInitialState(data.Faults);
    }
  }, [data]);

  useEffect(() => {
    if (state.refetch) {
      refetch();
      changeState({ refetch: false });
    }
  }, [state.refetch]);

  if (loading) return <Loading />;
  return (
    <Container maxWidth="lg">
      <section className="container">
        <div {...getRootProps({ className: "dropzone" })}>
          <input {...getInputProps()} />
          <p>Drag 'n' drop some files here, or click to select files</p>
        </div>
        <aside>
          <h4>Files</h4>
          <ul>{}</ul>
        </aside>
      </section>
      <MUIDataTable
        title={"Üretim Bilgileri"}
        data={_.orderBy(initialState, ["productDate"], ["desc"])}
        columns={columns}
        options={options}
      />
    </Container>
  );
}
